<template>
  <div class="ReChannelPostAdd pb-3">
    <ReFormPrinter :masFormConfig="masAllFormParams" SuccessBtnText="Отправить" />
    <!--в ФормПринтере нужна кнопка "Отмена", которая будет сбрасывать все поля формы, заполненные пользователем-->
    <!--весь блок postAddForm показывается только для тех, у кого есть хотя бы 1 канал, где он имеет право на редактирование -->
  </div>
</template>

<script>
import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";

export default {
  name: "ReChannelPostAdd",
  components: {
    ReFormPrinter
  },
  props: {
    counter: String,
    findId: {
      type: String,
      default: ""
    },
    objPost: Object
  },
  data() {
    return {
      masAllFormParams: this.currentFormConfig(),
      SuccessBtnText: ""
    };
  },
  computed: {},
  methods: {
    showPostForm() {
      this.isShown = !this.isShown;
    },
    currentFormConfig() {
      return require("src/conf/PostFormConfig.js").post_config;
      return [];
    }
  }
};
</script>

<style scoped>

</style>
